import React from "react"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select"

interface CategorySelectProps {
    value?: string
    onValueChange: (value: string) => void
}

export const CategorySelect: React.FC<CategorySelectProps> = ({
    value = "all",
    onValueChange,
}) => {
    return (
        <Select onValueChange={onValueChange} defaultValue={value}>
            <SelectTrigger className="w-[180px] rounded-full">
                <SelectValue placeholder="All Categories" />
            </SelectTrigger>
            <SelectContent className="z-[102]">
                <SelectItem value="all">All Categories</SelectItem>
                <SelectItem value="Category A">Category A</SelectItem>
                <SelectItem value="Category B">Category B</SelectItem>
                <SelectItem value="Category C">Category C</SelectItem>
                <SelectItem value="Category D">Category D</SelectItem>
            </SelectContent>
        </Select>
    )
}
